export class AvailableActionViewModelNew {
    public ActionTypeId: number;
    public ActionTypeName: string;
  
    /**
     *
     */
    constructor(Id: number, Name: string) {
      this.ActionTypeId = Id;
      this.ActionTypeName = Name;
    }
  }
export class AvailableActionsForComponentInInventoryWSRE {
    public actions = { // previous code new AvailableActionViewModelNew(46, 'Relube'), new AvailableActionViewModelNew(10302, 'Regrouser'),removed,  TT-5815
      // new AvailableActionViewModelNew(10203, 'Reseal Only On Bush'),
      Link: [new AvailableActionViewModelNew(8, 'Repair Dry Joints'), new AvailableActionViewModelNew(10805, 'Repair Component')],
      Bushing: [new AvailableActionViewModelNew(12, 'Turn Pins & Bushings'), new AvailableActionViewModelNew(10201, 'Replace Bush'), new AvailableActionViewModelNew(10805, 'Repair Component')],
      Shoe: [ new AvailableActionViewModelNew(10301, 'Replace with new shoe'), new AvailableActionViewModelNew(10302, 'Regrouser Shoe'),new AvailableActionViewModelNew(10805, 'Repair Component')],
      Idler: [new AvailableActionViewModelNew(10401, 'Replace With New Idler'), 
        // new AvailableActionViewModelNew(17, 'Swap Front Rear Idler'), 
        new AvailableActionViewModelNew(10805, 'Repair Component')],
       CarrierRoller: [new AvailableActionViewModelNew(10602, 'Swap Carrier Roller Position'), new AvailableActionViewModelNew(10601, 'Replace With New Carrier Roller'), new AvailableActionViewModelNew(10805, 'Repair Component')],
      TrackRoller: [ new AvailableActionViewModelNew(10701, 'Replace With New Track Roller'), new AvailableActionViewModelNew(10805, 'Repair Component')],
      Sprocket: [new AvailableActionViewModelNew(10501, 'Replace With New Sprocket'), new AvailableActionViewModelNew(10805, 'Repair Component')],
      Guard: [new AvailableActionViewModelNew(10801, 'Replace With New Guard'), new AvailableActionViewModelNew(10805, 'Repair Component')],
      NoActions: [new AvailableActionViewModelNew(0, 'No Actions Available'), new AvailableActionViewModelNew(10805, 'Repair Component')],
      Crawler: [new AvailableActionViewModelNew(10803, 'Replace With New Crawler Frame Guide'), new AvailableActionViewModelNew(10805, 'Repair Component')],
      RSRearIdler: [new AvailableActionViewModelNew(10804, 'Replace With New RS Rear Idler'), new AvailableActionViewModelNew(10805, 'Repair Component')],
  
    };
  
  
    public GetActions(compartTypeId: number) {
      switch (compartTypeId) {
        case 230: return this.actions.Link;
        case 231: return this.actions.Bushing;
        case 232: return this.actions.Shoe;
        case 233: return this.actions.Idler;
        case 234: return this.actions.CarrierRoller;
        case 235: return this.actions.TrackRoller;
        case 236: return this.actions.Sprocket;
        case 237: return this.actions.Guard;
        case 417: return this.actions.Crawler;
        case 446: return this.actions.RSRearIdler;
        default: return this.actions.NoActions;
      }
    }
  }